module.exports = "/build/web/svg/webshop-card.6ab9cf34bc9babae35e93efde0f290e1.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/webshop-card.svg
// module id = 236
// module chunks = 24